import React from "react";

import "./App.css";

import "./styles/app/TopBanner.css";
import "./styles/app/TablePicker.css";
import "./styles/app/SplitBill.css";
import "./styles/app/SplitBillMenu.css";
import "./styles/app/Rotate.css";
import "./styles/app/RestaurantSearch.css";
import "./styles/app/RegistrationForm.css";
import "./styles/app/PaymentConfirmation.css";
import "./styles/app/ApplePayButton.css";
import "./styles/app/PayBy.css";
import "./styles/app/OrderOrPay.css";
import "./styles/app/Numpad.css";
import "./styles/app/Modal.css";
import "./styles/app/MainLoading.css";
import "./styles/app/Loading.css";
import "./styles/app/Legal.css";
import "./styles/app/Home.css";
import "./styles/app/LoginForm.css";
import "./styles/app/Footer.css";
import "./styles/app/ErrorModal.css";
import "./styles/app/Bill.css";
import "./styles/app/ApplyVoucher.css";
import "./styles/app/ApplyGratuity.css";
import "./styles/app/AllergensFilter.css";
import "./styles/app/NavMenu.css";
import "./styles/app/MenuFooter.css";
import "./styles/app/Menu.css";
import "./styles/app/MenuHome.css";
import "./styles/app/MenuItem.css";
import "./styles/app/Basket.css";
import "./styles/app/MenuCheckin.css";
import "./styles/app/MenuErrorModal.css";
import "./Firefox_fix.css"; //Css for Firefox
import "./Safari10_1.css"; //Css for Safari 10.1+
import "./screenSizes.css";

// import Flow from './flows/Milano';
import Flow from './flows/Milano';

export default () => <Flow />;
